import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import type { RootState } from '@/redux/store';
import { COMPLIANCE_CUSTOMERS_LIST_PAGE_SIZE } from '@/config/complianceCustomersList';
import { complianceAPI } from '@/api';
import type {
  ComplianceCustomerRequest,
  ComplianceCustomerResponse,
  UpdateCustomerRequest,
} from '@/api';
import { complianceCustomersActions } from '@/redux/actions';
import { complianceCustomersMappers } from '@/redux/mappers';

function* listCustomers(
  action: PayloadAction<ComplianceCustomerRequest>,
): SagaIterator {
  try {
    const { payload } = action;

    const response: ComplianceCustomerResponse = yield call(
      complianceAPI.listCustomers,
      payload,
    );

    const data = complianceCustomersMappers.fetchCustomers(response);
    yield put(complianceCustomersActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceCustomersActions.setLoading(false));
  }
}

function* updateCustomer(
  action: PayloadAction<UpdateCustomerRequest>,
): SagaIterator {
  try {
    yield call(complianceAPI.updateCustomer, action.payload);
    const lastListRequest: ComplianceCustomerRequest | null = yield select(
      (state: RootState) => state.complianceCustomers.lastListRequest,
    );
    const listParams =
      lastListRequest ??
      ({
        limit: COMPLIANCE_CUSTOMERS_LIST_PAGE_SIZE,
        offset: 0,
      } as ComplianceCustomerRequest);
    yield put(complianceCustomersActions.listCustomers(listParams));
  } catch (error: unknown) {
    yield put(complianceCustomersActions.setLoading(false));
  }
}

export { listCustomers, updateCustomer };
